import React from "react";
import AsyncSelect from "react-select/async";
import api from "./api";

/**
 * value: [{ value: siteId, label: "SITE_ID - Site Name" }]
 * onChange: setSelectedSites
 */
export default function AsyncSiteSelect({ value, onChange }) 
{
  const loadOptions = async (inputValue) => {
    const res = await api.get("/solution/sites/search", {
      params: { q: inputValue }
    });

    return res.data.map(site => ({
      value: site.siteId || site._id,   // ✅ REQUIRED
      label: site.name,                 // display text
    }));
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={true}
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      isMulti
      placeholder="Search & select sites…"
      styles={{
        container: (base) => ({ ...base, minWidth: 260 }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
      }}
    />
  );
}
